/**
 * @Author: DJ
 * @Date:   2021-08-04 13:55:09
 * @Last Modified by:   DJ
 * @Last Modified time: 2021-09-10 23:18:47
 */
import React, { useState, useEffect, useRef } from 'react';
import { Button, Table, Form, Input, Select } from 'antd';
import { XPagination } from '@/components/xqxc_ui';
import { tooltipStyle, tooltip, ImgCell } from '@/components/TableCell';
import { connect } from 'react-redux';
import styles from './index.module.scss';
import CertificateInfo from './certificateInfo';
import KeepAlive from '@/routes/KeepAlive';
import { SearchBox, SearchItem } from '@/components/Layout';
import { XInput, XInputNum, XSelect, XDatePicker, XOKButton, XCancelButton } from '@/components/xqxc_ui';
import PropTypes from 'prop-types';
import { setBreadcrumbPaths } from '@/reducers/home/actions';
import { jkzList, getEnum } from './api';

import ButtonPerssion from '@/routes/ButtonPerssion';

const Index = (props) => {
    // const [visible, setVisible] = useState(false);
    const page = useRef({pageNum: 1, pageSize: 30});
    const [aliveInit, setAliveInit] = useState(false);
    const [walletInfo, setWalletInfo] = useState({});
    const [dataSource, setDataSource] = useState({});
    // const [pagenation, setPagenation] = useState({ pageSize: 30, pageNum: 1 });
    const [riderStatusEnum,setRiderStatusEnum] = useState([]);
    const [phone, setPhone] = useState('');
    const [name, setName] = useState('');
    const [workState, setWorkState] = useState({});
    const [riderState, setRiderState] = useState({});
    const [auditState, setAuditState] = useState({});
    const [healthCertificateState, setHealthCertificateState] = useState({});
    const [reset, setReset] = useState();
     
    useEffect(() => {
        props.setBreadcrumbPaths(props.match);
    }, []);

    // useEffect(()=>{
    //     // setAuditStateType({auditState:'WAIT_AUDIT'});
    //     form.setFieldsValue({auditState:'WAIT_AUDIT'});
    //     searchList({auditState:'WAIT_AUDIT'});
    // },[]);

    useEffect(()=>{
        getEnum({enumName:'RiderStatusEnum'}).then(res=>{
            if(res && res.errCode===0){
                setRiderStatusEnum(res.result);
            }
        });
    },[]);


    useEffect(()=>{
        if(aliveInit){
            search();
        }
    }, [aliveInit]);

    useEffect(()=>{
        if(aliveInit){
            search();
        }
    }, [reset]);

    const searchList=(obj)=>{
        jkzList(obj).then(res=>{
            if(res && res.errCode===0){
                setDataSource(res.result);
                // setPagenation({pageNum:res.result.pageNum,pageSize:res.result.pageSize});
            }
        });
    };


    const paginationChange = (pageSize, pageNum)=>{
        page.current = {pageNum, pageSize};
        search();
    };

    const viewInfo = (data) =>{
        const auth = localStorage.getItem('auth');
        const loginUserId = JSON.parse(auth).userInfo.loginUserId;
        props.history.push(`/home/audit/healthcertificate/view/${data.id}/${loginUserId}`);
    };


    const auditInfo = (data) =>{
        const auth = localStorage.getItem('auth');
        const loginUserId = JSON.parse(auth).userInfo.loginUserId;
        props.history.push(`/home/audit/healthcertificate/audit/${data.id}/${data.riderId}/${loginUserId}`);
    };


    const search = ()=>{
        let params = {
            phone,
            name,
            workState: workState.code,
            riderState: riderState.code,
            auditState: auditState.code,
            healthCertificateState: healthCertificateState.code,
            pageNum: page.current.pageNum,
            pageSize: page.current.pageSize
        };

        KeepAlive.saveCache({ ...params });
        searchList(params);
        // api.getCrowdsourcingRiderList(params).then(res=>{
        //     setRiderList(res.result);
        // }).catch(err=>{
        //     message.error(err.message);
        // });
    };

    const onReset = ()=>{
        setPhone('');
        setName('');
        setRiderState({});
        setAuditState({});
        setWorkState({});
        setHealthCertificateState({});
        page.current = {pageNum:1,pageSize:30};
        setReset(Date.now());
    };

    const initData = (data)=>{
  
        if(data.auditState){
            setPhone(data.phone);
            setName(data.name);
            setRiderState({code:data.riderState} || {});
            setWorkState({code:data.workState} || {});
            setHealthCertificateState({code:data.healthCertificateState} || {});
            page.current={pageSize:data.pageSize,pageNum:data.pageNum};
            setAuditState({code:data.auditState} || {});
        }else{
            setAuditState({code:'WAIT_AUDIT'} || {});
        }
        setAliveInit(true);
    };

    const columns = [
        {
            title: '骑士账号',
            key: 'phone',
            dataIndex: 'phone',
            align: 'center',
            width: 120,
            onCell: tooltipStyle,
            render: tooltip,
        },
        {
            title: '姓名',
            key: 'name',
            dataIndex: 'name',
            align: 'center',
            width: 120,
            onCell: tooltipStyle,
            render: tooltip,
        },
        {
            title: '骑士状态',
            key: 'riderStateStr',
            align: 'center',
            dataIndex: 'riderStateStr',
            width: 120,
            onCell: tooltipStyle,
            render: tooltip,
        },
        {
            title: '工作状态',
            key: 'workStateStr',
            dataIndex: 'workStateStr',
            align: 'center',
            width: 120,
            onCell: tooltipStyle,
            render: tooltip,
        },
        {
            title: '提交时间',
            key: 'commitTime',
            dataIndex: 'commitTime',
            align: 'center',
            width: 150,
            onCell: tooltipStyle,
            render: tooltip,
        },
        {
            title: '审核状态',
            key: 'auditStateStr',
            dataIndex: 'auditStateStr',
            align: 'center',
            width: 120,
            onCell: tooltipStyle,
            render: tooltip,
        },
        {
            title: '健康证状态',
            key: 'healthCertificateStateStr',
            width: 120,
            dataIndex: 'healthCertificateStateStr',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip,
        },
        {
            title: '操作',
            align: 'center',
            width: 120,
            // eslint-disable-next-line react/display-name
            render: (_,data) => (
                <div>
                    <a onClick={()=>{viewInfo(data);}}>
                    查看
                        
                    </a>
                    {(data.auditState ==='WAIT_AUDIT') && <ButtonPerssion code='audit/healthcertificate/pcshgljkzsh'>
                    <a style={{marginLeft: '5px'}} onClick={()=>{auditInfo(data);}}>
                        审核
                    </a>
                    </ButtonPerssion>}
                    
                </div>
            ),
        },
    ];

    return (
        <KeepAlive render={(state) => {
            if (!aliveInit) {
                initData(state);
            }
        }}>
       
        <div className={`${styles.listview} ${styles.flexBoxContainer}`}>
            <SearchBox>
                    <SearchItem>
                        <XInput
                            label='手机号'
                            placeholder='请输入手机号码'
                            value={phone}
                            bindThis={setPhone}
                            bindName='phone'
                            maxLength={11}
                            mode='number'
                            allowClear={true}
                        />
                    </SearchItem>
                    <SearchItem>
                        <XInput
                            label='姓名'
                            placeholder='请输入姓名'
                            value={name}
                            bindThis={setName}
                            bindName='name'
                            allowClear={true}
                        />
                    </SearchItem>
                    <SearchItem>
                        <XSelect
                            label='工作状态'
                            placeholder='请选择工作状态'
                            renderData={[{value:'开工',code:'START'},{value:'收工',code:'END'},]}
                            dataIndex='value'
                            keyIndex='code'
                            value={workState.code}
                            bindThis={setWorkState}
                            bindName='workState'
                            showSearch={true}
                            allowClear={true}
                            isOptionBindID={true}
                        />
                    </SearchItem>
                    <SearchItem>
                        <XSelect
                            label='骑士状态'
                            placeholder='请选择骑士状态'
                            renderData={riderStatusEnum}
                            dataIndex='value'
                            keyIndex='code'
                            value={riderState.code}
                            bindThis={setRiderState}
                            bindName='riderState'
                            showSearch={true}
                            allowClear={true}
                            isOptionBindID={true}
                        />
                    </SearchItem>
                    <SearchItem>
                        <XSelect
                            label='审核状态'
                            placeholder='请选择审核状态'
                            renderData={[{value:'待审核',code:'WAIT_AUDIT'},{value:'审核通过',code:'PASS_AUDIT'},{value:'审核未通过',code:'FAIL_AUDIT'},]}
                            dataIndex='value'
                            keyIndex='code'
                            value={auditState.code}
                            bindThis={setAuditState}
                            bindName='auditState'
                            showSearch={true}
                            allowClear={true}
                            isOptionBindID={true}
                        />
                    </SearchItem>
                    <SearchItem>
                        <XSelect
                            label='健康证状态'
                            placeholder='请选择审核状态'
                            renderData={[{value:'有效期内',code:'NORMAL'},{value:'即将过期',code:'EXPIRING'},{value:'过期',code:'EXPIRED'},]}
                            dataIndex='value'
                            keyIndex='code'
                            value={healthCertificateState.code}
                            bindThis={setHealthCertificateState}
                            bindName='healthCertificateState'
                            showSearch={true}
                            allowClear={true}
                            isOptionBindID={true}
                        />
                    </SearchItem>
                    <SearchItem>
                        <XOKButton
                            label='查询'
                            onClick={search}
                        />
                        <XCancelButton
                            label='重置'
                            onClick={onReset}
                        />
                    </SearchItem>
                </SearchBox>

                <div className={styles.tableContainer} style={{marginBottom:'5px'}}>
                    <Table
                        rowKey={(record) => record.id}
                        pagination={false}
                        fixed={true}
                        scroll={{ y: true }}
                        columns={columns}
                        dataSource={dataSource.dataList}
                    />
                    <XPagination
                        resultTotal={dataSource.resultTotal}
                        pageSize={dataSource.pageSize}
                        pageNum={dataSource.pageNum}
                        onChange={paginationChange}
                    />
                </div>
        </div>
        </KeepAlive>
    );
};

Index.propTypes = {
    history: PropTypes.object, //路由对象
    match: PropTypes.object,
    setBreadcrumbPaths: PropTypes.func,
};

export default connect(null, { setBreadcrumbPaths })(Index);
